<template>
  <div class="atividades-monitoramentoescala ml-4 mr-4" >
      <b-form> 

          <b-row>
              <b-col cols="1" class="mt-2 pr-4" >
                  <b-form-group label="" label-for="tabela-foto">
                    <b-img                         
                        class="mb-2" 
                        v-model="operador.foto_url"                         
                        v-bind="mainProps" rounded alt="Foto"
                        
                        :src="operador.foto_url"
                    >
                    </b-img>
                  </b-form-group>
                  
              </b-col>  
             
              <b-col>

                <!-- NOME -->     
                <b-row >
                    <b-col cols=4 class="mt-3 ">
                        <b-form-input id="fot-nome" 
                            type="text" 
                            readonly                       
                            v-model="operador.nome"                         
                            placeholder="Nome funcionário" 
                        />                        
                    </b-col>
<!--
                    <b-col cols=1 class="mt-3 ">
                        <b-form-input id="fot-admissao" 
                            type="text" 
                            readonly                       
                            v-model="operador.dt_admissao"                            
                            placeholder="Admissão" 
                        />                                                
                    </b-col>                     
                    -->
                </b-row>


                <!-- FUNÇÃO e CHN -->     
                <b-row >
                   
                    <b-col cols=2 class="mt-2">
                        <b-form-input id="fot-funcao" 
                            type="text"   
                            readonly                     
                            v-model="operador.funcao"                         
                            placeholder="Função" 
                        />                        
                    </b-col>

                    <b-col cols=2 class="mt-2">                        
                        <b-form-input id="fot-celular" only
                            type="text"
                            readonly   
                            v-mask="'#####-###'"                     
                            v-model="operador.celular"                         
                            placeholder="Celular" 
                        />
                    </b-col>     
                    <!--                  

                    <b-col cols=1 class="mt-2">                        
                        <b-form-input id="fot-cnh" 
                            type="text"  
                            readonly                      
                            v-model="operador.cnh_cat"                         
                            placeholder="CNH" 
                        />
                    </b-col>                      
                    -->
                                                                  
                </b-row>

                <!-- RE e CELULAR -->     
               
                <b-row >
                    <b-col cols=1 class="mt-4">
                        <b-form-input id="fot-registro" 
                            type="text"
                            required                        
                            v-model="registro" 
                            @keyup.enter="loadOperador()"                                                
                            placeholder="1818" 
                        />                        
                    </b-col> 
                    
                    <b-col cols=2 class="mt-4">
                        <div>   
                                <b-form-datepicker id="esc_data_servico"  v-model="data_operacao"  required placeholder="Selecione uma data" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                            </div>                     
                    </b-col>                 


                <b-col cols=1 class="mt-4">
                    <b-button size="sm" variant="primary" class="mr-2 mt-2" :disabled="carregando" @click="carregando = true,loadOperador(),loadEscalaServico()">
                      <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Pesquisar
                    </b-button>   
                </b-col>

                <LoadingModal v-if="isLoading" />
             
                </b-row>

                            


              </b-col>              
          </b-row>

          
    </b-form>
    <hr>
    <b-table small hover striped sticky-header="618px"  :items="escala" :fields="fields">                           
        
    </b-table>      
    </div>
</template>

<script>
import { baseApiUrl,showError } from '@/global'
import axios from 'axios'
import moment from 'moment'
import { mapState } from 'vuex' 
import LoadingModal from '../utilitarios/LoadingModal'



export default {    
    name: 'TraAtividadesProgramadasRealizadas',

    data: function() {
        return {
            mode: 'save',
            isLoading: false,
            carregando: false,
            operadores:{},
            operador: [],            
            escala:[],
            data_operacao: '',

            




            mainProps: { blankColor: '#777', width: 157, height: 161, class: 'm1' },


            
            fields: [
                

                { key: 'DATA_SERVICO', label: 'Data Serviço', sortable: true, formatter: (value, key, escala) => {
                    return moment(escala.DATA_SERVICO).format('DD/MM/YYYY');} },
                { key: 'LINHA', label: 'Linha', sortable: true },
                { key: 'TABELA', label: 'Tabela', sortable: true },
               // { key: 'loc_ini_linha', label: 'Linha inicio', sortable: true },                
                
                { key: 'JORNADA_INICIO', label: ' Linha inicio ', sortable: true }, 
                { key: 'JORNADA_FIM', label: 'Linha término', sortable: true },
                { key: 'PREFIXO', label: 'Carro', sortable: true },
               // { key: 'modalidade', label: 'Modalidade', sortable: true },

                { key: 'MOTORISTA_REGISTRO', label: 'Mot RE', sortable: true },
                { key: 'MOTORISTA_PEGADA', label: 'Motorista local pegada', sortable: true },
               // { key: 'mot_loc_largada', label: 'Motorista local largada', sortable: true },

                { key: 'MOTORISTA_INICIO', label: 'Mot Jor inicio', sortable: true, formatter: (value, key, escala) => {
                    return moment(escala.MOTORISTA_INICIO).format('MM/DD/YYYY HH:mm').replace('Data inválida','-');} },

                { key: 'MOTORISTA_FIM', label: 'Mot Jor Fim', sortable: true, formatter: (value, key, escala) => {
                    return moment(escala.MOTORISTA_FIM).format('MM/DD/YYYY HH:mm').replace('Data inválida','-');} },



                { key: 'COBRADOR_REGISTRO', label: 'Cob RE', sortable: true },
                { key: 'COBRADOR_PEGADA', label: 'Cobrador local pegada', sortable: true },
              //  { key: 'cob_loc_largada', label: 'Cobrador local largada', sortable: true },

                { key: 'COBRADOR_INICIO', label: 'Cob Jor inicio', sortable: true, formatter: (value, key, escala) => {
                    return moment(escala.COBRADOR_INICIO).format('MM/DD/YYYY HH:mm').replace('Data inválida','-');} },

                { key: 'COBRADOR_FIM', label: 'Cob Jor Fim', sortable: true, formatter: (value, key, escala) => {
                    return moment(escala.COBRADOR_FIM).format('MM/DD/YYYY HH:mm').replace('Data inválida','-');} },

                { key: 'COBRADOR_INICIO', label: 'Cob Jor inicio', sortable: true },
                { key: 'COBRADOR_FIM', label: 'Cob Jor Fim', sortable: true }
                
            ]
        }        
    },

    computed: mapState(['user']),

    components: {LoadingModal    },
    methods: {

        async loadOperador() { 
            let corpo = {                             
            "registro": `${this.registro}`,
            "id_empresa": `${this.user.id_empresa}`
            }; 
            
          const url = `${baseApiUrl}/glo/escala/consulta`
          axios.post(url,corpo).then(res => { this.operador = res.data })   
                      this.carregando = false;       
                      this.escala = []
        },  

        async loadEscalaServico() { 
            this.isLoading = true; // Ative o indicador de carregamento                                    
            let corpo = {                
            "id_operador": `${this.operador.id_funcionario_erp}` ,                     
            "data_servico": `${this.data_operacao}`                      
          }; 
          const url = `${baseApiUrl}/glo/escala/consulta/servico`
          axios.post(url,corpo)
          .then(res => {
            this.carregando = false;               
            this.escala = res.data 
             this.isLoading = false; // Desative o indicador de carregamento   
            })          
        .catch(showError)
            
        }, 



        
       
    },

    mounted() { 
       // this.loadFormatarData()
       //this.loadOperador()           
       //this.loadEscalaServico()
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.table{
    font-size: 0.7em;
}
</style>

